import { IconArrowNarrowRight } from "@tabler/icons-react";
import { useTranslations } from "next-intl";
import EmptyCartSvg from "@/assets/icons/empty-cart.svg";
import { Button } from "@/components/ui/button";
import { getLocaleForPathname, Link } from "@/i18n/navigation";

export const EmptyCart = () => {
  const t = useTranslations();
  const locale = getLocaleForPathname();
  return (
    <div className="grid h-full w-full place-items-center space-y-2 py-16">
      <EmptyCartSvg />
      <div className="text-center font-semibold text-3xl">
        {t("cart.emptyCart.title")}
      </div>
      <div className="text-center font-medium text-lg">
        <Link href="/diets" locale={locale}>
          <Button variant="secondary" className="h-14 px-12 py-3">
            {t("cart.emptyCart.cta")}
            <IconArrowNarrowRight stroke={1.25} className="ml-2" />
          </Button>
        </Link>
      </div>
    </div>
  );
};
